import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-explore-three',
  templateUrl: './breadcrumb-explore-three.component.html',
  styleUrls: ['./breadcrumb-explore-three.component.scss']
})
export class BreadcrumbExploreThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
